module.exports = __webpack_public_path__ + "img/合家好（个人）.4e95e7ef.png";